import { Divider, IconButton, Stack, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import useAxios from "../hooks/useAxios";
import VideoThumbnailSkeleton from "./Skeletons/VideoThumbnailSkeleton";
import VideoThumbnail from "./VideoThumbnail";

const incrementLimit = 5;

export default function HorizontalVideoGroup({
  title,
  categoryId,
  last,
  activeFilter,
  setLoading,
}) {
  const [videosArray, setVideoArray] = useState([]);
  const [fetchFlag, setFetchFlag] = useState(true);
  const [limit, setLimit] = useState(incrementLimit);
  const [reachEnd, setreachEnd] = useState(false);
  const navigate = useNavigate();
  const axios = useAxios();

  const fetchVideos = useCallback(
    async (limit, currentVideosLength) => {
      activeFilter && setLoading(true);
      setFetchFlag(true);
      let url = `category/${categoryId}/content?limit=${limit}`;
      setLimit((prev) => prev + incrementLimit);
      if (activeFilter) {
        url = url + "&order=" + activeFilter;
      }
      try {
        const response = await axios.get(url);
        setVideoArray(response.data.contents);
        // setVideoArray((prev) => {
        //   return [...prev].concat(response.data.contents);
        // });
        if (
          response.data.contents?.length % incrementLimit !== 0 ||
          currentVideosLength === response.data.contents?.length
        )
          setreachEnd(true);
      } catch (error) {}
      activeFilter && setLoading(false);
      setFetchFlag(false);
    },
    [categoryId, activeFilter, axios, setLoading]
  );

  useEffect(() => {
    setLimit(incrementLimit);
    fetchVideos(limit, videosArray.length);
  }, [fetchVideos]);

  const handleNavigateToFeed = () => {
    navigate("/catagory/" + categoryId);
  };

  const skeletonArray = [...Array(5)].map(() => (
    <VideoThumbnailSkeleton key={Math.random()} />
  ));

  const videoThumbs = videosArray?.map((video) => {
    return (
      <VideoThumbnail
        key={Math.random()}
        src={video?.thumbnail}
        duration={video?.details?.duration}
        title={video?.title?.ar}
        videoId={video?.id}
        catagoryId={video?.category_id}
      />
    );
  });

  return (
    <>
      {title && (
        <Stack
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
          px={3}
        >
          <Typography variant="h5">{title}</Typography>
          <Typography
            variant="subtitle1"
            display={{ sx: "inline", md: "none" }}
            sx={{
              ":hover": {
                cursor: "pointer",
              },
            }}
            onClick={handleNavigateToFeed}
          >
            عرض المزيد
          </Typography>
        </Stack>
      )}

      <Stack
        flexDirection="row"
        justifyContent="flex-start"
        gap={2}
        overflow={{ xs: "scroll", md: "wrap" }}
        flexWrap={{ xs: "nowrap", md: "wrap" }}
        px={2}
      >
        {videoThumbs}
        {(videosArray?.length <= 0 || fetchFlag) && skeletonArray}
        {!fetchFlag && +categoryId === 0 && (
          <Typography
            variant="subtitle1"
            display={{ sx: "inline", md: "none" }}
            p={2}
            sx={{
              ":hover": {
                cursor: "pointer",
              },
            }}
            onClick={() => navigate(`/catagory/0?order=${activeFilter}`)}
          >
            عرض المزيد
          </Typography>
        )}
      </Stack>

      {!fetchFlag && !reachEnd && (
        <IconButton
          size="small"
          sx={{ borderRadius: "0px", display: { xs: "none", md: "block" } }}
          onClick={fetchVideos.bind(this, limit, videosArray.length)}
        >
          <BsChevronDown />
        </IconButton>
      )}

      {!last && <Divider sx={{ mb: 2, mt: 1 }} mx={5} />}
    </>
  );
}
